(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('chart', {
                parent: 'module',
                url: '/chart',
                data: {
                    authorities: ['ROLE_DATA_STATISTICS']
                },
                views: {
                    'content': {
                        templateUrl: 'app/chart/chart.html',
                        controller: 'ChartController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('merchant-chart', {
                parent: 'module',
                url: '/merchant-chart',
                data: {
                    authorities: ['ROLE_MERCHANT_CHART']
                },
                views: {
                    'content': {
                        templateUrl: 'app/chart/merchant-chart.html',
                        controller: 'MerchantChartController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplier-download-chart', {
                parent: 'module',
                url: '/supplier-download-chart',
                data: {
                    authorities: ['ROLE_SUPPLIER_DOWNLOAD_CHART']
                },
                views: {
                    'content': {
                        templateUrl: 'app/chart/supplier-download-chart.html',
                        controller: 'SupplierDowmloadChartController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('replenishment-chart', {
                parent: 'module',
                url: '/replenishment-chart',
                data: {
                    authorities: ['ROLE_DATA_STATISTICS']
                },
                views: {
                    'content': {
                        templateUrl: 'app/chart/replenishment-chart.html',
                        controller: 'ReplenishmentChartController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('deliver-chart', {
                parent: 'module',
                url: '/deliver-chart',
                data: {
                    authorities: ['ROLE_DATA_STATISTICS']
                },
                views: {
                    'content': {
                        templateUrl: 'app/chart/deliver-chart.html',
                        controller: 'DeliverChartController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }
})();
